import FirstSectionQuestions from './components/FirstSectionQuestions';
import MoreQuestionSection from './components/MoreQuestionSection';
import { useState, useEffect } from 'react';
import { getProfileEditDetails } from '../../services/memberService';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { EditProfileDataState } from '../../typings/editProfile';
import { getMemberMedia } from '../../services/mediaService';
import { MemberMediaProps } from '../../typings/memberMedia';
import MemberMedia from './components/MemberMediaContainer';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import EditProfileLoader from './components/EditProfileLoader';
import VerifiedProfileSection from './components/VerifiedProfileSection';
import EditProfileImages from './components/EditProfileImages';

const EditProfile = () => {
   const [isLoading, setIsLoading] = useState<boolean>(false);
   const [editData, setEditData] = useState<EditProfileDataState>();
   const [mediaData, setMediaData] = useState<MemberMediaProps[]>();
   const [profilePercentage, setProfilePercentage] = useState<number>(0);
   const { memberCode: myMemberCode } = useSelector((state: RootState) => state.member);
   const member = useSelector((state: RootState) => state.member);
   let history = useHistory();

   useEffect(() => {
      window.scrollTo(0, 0);
      getEditProfileData();
   }, [])

   const getEditProfileData = async () => {
      setIsLoading(true);
      const { data } = await getProfileEditDetails(myMemberCode);
      const { data: media } = await getMemberMedia(myMemberCode);
      calculatePercentage(data, media);
      setEditData(data);
      setMediaData(media);
      setIsLoading(false);
   };

   const calculatePercentage = (edit: EditProfileDataState, media: MemberMediaProps[]) => {
      let percentage = 0;
      let questionsAnswerd = 0;
      let minAnswers = 0;
      const totalQuestionsPercentage = 25;
      let sum = 0;
      for (let i = 0; i < edit.questions.length; i++) {
         sum += 100 / edit.questions.length;
         if (sum >= 75) {
            minAnswers = i;
            break;
         }
      }
      const persentagePerAnsweredQuestion = totalQuestionsPercentage / minAnswers;

      if (media.length > 0) {
         for (let img of media)
            if (img.isProfilePicture)
               percentage += 30;
      }

      if ((edit?.aboutMeSentence?.length ?? 0) > 5)
         percentage += 20;

      if (member.profileIsVerified) {
         percentage += 25;
      }

      for (let question of edit.questions) {
         if (question.answers.length > 0 && question.answers[0] !== 'לא רלוונטי' && question.answers[0] !== '') {
            questionsAnswerd++;
            // percentage += persentagePerAnsweredQuestion;
         }
      }

      percentage += persentagePerAnsweredQuestion * questionsAnswerd > totalQuestionsPercentage ? totalQuestionsPercentage : persentagePerAnsweredQuestion * questionsAnswerd;

      setProfilePercentage(Math.round(percentage) > 100 ? 100 : Math.round(percentage));
   }


   if (isLoading) return <EditProfileLoader />
   return (
      <>
         <div className="top_sec signup wf-section">
            <div className="signup_status_group">
               {/* <div className="status_num"> */}
               {/* <h1 className='top_title edit'>פרופיל {profilePercentage}% מלא</h1> */}
               <h1 className='top_title edit'>עריכת פרופיל <span style={{ fontWeight: 400 }}>({profilePercentage}% מלא)</span></h1>

               {/* </div> */}
               <a href="#" onClick={() => history.goBack()} className="top_back signup w-inline-block">
                  <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
               </a>
            </div>
            <div className="progress_bar">
               <div className="progress_line" style={{ width: `${profilePercentage}%` }} />
            </div>
         </div>
         <div className="content_sec signup wf-section">
            <div className="login_sec w-form">
               <div className="form_field_content picts_edit">
                  {
                     // mediaData &&
                     // <MemberMedia memberImages={mediaData} />
                     mediaData && <EditProfileImages mediaData={mediaData} />
                  }

               </div>
               <div className="form_field_content edit">
                  {
                     editData &&
                     <FirstSectionQuestions
                        memberNickName={editData.memberNickName}
                        personalStatusName={editData.personalStatusName}
                        lookingFor={editData.lookingFor}
                        aboutMeSentence={editData.aboutMeSentence}
                        birthDate={editData.birthDate}
                        locationName={editData.location}
                        height={editData.height}
                     />
                  }
               </div>
               <div className="form_field_content prior_edit">
                  <label htmlFor="name" className="field_title">
                     עוד קצת עליך
                  </label>
                  <div className="search_field_txt edit">
                     הפרטים הבאים יעזרו לנו להציג לך אנשים שמתאימים לך בדיוק
                  </div>
                  {
                     editData && editData.questions ?
                        <MoreQuestionSection questions={editData.questions} />
                        : null
                  }
               </div>
               {/* <div className="form_field_content edit_check">
                  <VerifiedProfileSection editData={editData} />
               </div> */}
            </div>
         </div>
      </>
   )
}

export default EditProfile;
